import { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import Icon from 'react-native-vector-icons/AntDesign';
import Colors from '../../constants/Colors';

export type IconButtonPropsType = {
  icon: string;
  disabled?: boolean;
  style?: any;
  iconStyle?: any;
  onPress: () => void;
};

export const IconButtonStyle = StyleSheet.create({
  iconButtonContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
  },
  iconButtonIcon: {
    color: Colors.mocks.textDarkBlue,
    fontSize: 24,
    alignSelf: 'center',
  },
});

export const WideIconButtonStyle = StyleSheet.create({
  container: {
    backgroundColor: Colors.mocks.backgroundColorLightGray,
    borderRadius: 28,
    shadowColor: '#111',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.2,
    // elevation: 2,
    minWidth: 40,
    minHeight: 40,
    height: 44,
    width: 44,
    justifyContent: 'center',
  },
  icon: {
    color: '#fff',
    fontSize: 24,
    alignSelf: 'center',
  },
});

function IconButton(props: IconButtonPropsType) {
  const [disabled, setDisabled] = useState(props.disabled);

  useEffect(() => {
    setDisabled(props.disabled);
  }, [props.disabled]);

  const containerStyle = [IconButtonStyle.iconButtonContainer, props.style];
  return (
    <TouchableOpacity
      style={[containerStyle, disabled ? { backgroundColor: 'gray' } : {}]}
      disabled={disabled}
      onPress={() => (typeof props.onPress === 'function' ? props.onPress() : () => {})}
    >
      <Icon name={props.icon} style={[IconButtonStyle.iconButtonIcon, props.iconStyle]} />
    </TouchableOpacity>
  );
}

IconButton.defaultProps = {
  disabled: false,
  style: {},
  iconStyle: {},
};

export default IconButton;
